Ext.define('SA.view.ReportGrid', {
    alias: 'widget.report-grid',
    extend: 'SA.view.Grid',

    cls: 'sa-report-grid',

    applyHeaderWrapping(column) {
        var html = column.text,
            textWidth = column.textAutoWidth,
            columnWidth = column.width,
            frameWidth = 29,
            maxTextWidth = columnWidth - frameWidth,
            wrappable = /\S\s+\S/.test(html), 
            ellipsis = '\u2026',
            el = column.el,
            htmlEncode = Ext.String.htmlEncode,
            multiLineCls = 'sa-report-grid-column-multiline',
            parser = SA.data.HtmlParser,
            tm, subHtmls, widths, index, len, subHtml, parsedHtml;

        if (columnWidth < 50) {
            Ext.fly(el).removeCls(multiLineCls);
            Ext.fly(el).update(ellipsis);

            return;
        }

        if (column.encodeText) {
            html = htmlEncode(html);
        }

        Ext.fly(el).update(html);

        if (wrappable && textWidth > maxTextWidth) {
            Ext.fly(el).addCls(multiLineCls);

            tm = this.headerTextMetrics;

            if (tm.getHeights(html, [maxTextWidth])[0] > 40) {

                subHtmls = [];

                parsedHtml = parser.tokenize(html);

                for (index = 8, len = parsedHtml.length ; index < len ; index += 8) {
                    subHtmls.push(parser.tail(parsedHtml, -index));
                }

                widths = tm.getWidths(subHtmls.map(parsedHtml => ellipsis + parsedHtml.tokens.join('')));

                for (index = 0, len = widths.length ; index < len ; ++index) {
                    if (widths[index] > maxTextWidth) {
                        break;
                    }
                }

                index = Math.min(index, subHtmls.length - 1);

                subHtml = subHtmls[index];

                subHtmls.length = 0;

                for (index = 0 ; index < 8 ; ++index) {
                    subHtml = parser.tail(subHtml, 1);

                    subHtmls.push(ellipsis + subHtml.tokens.join(''));
                }

                widths = tm.getWidths(subHtmls);

                for (index = 0 ; index < 8 ; ++index) {
                    if (widths[index] <= maxTextWidth) {
                        break;
                    }
                }

                subHtml = subHtmls[index];

                Ext.fly(el).update(
                    '<div class="sa-report-grid-column-text-first" style="width: ' + maxTextWidth + 'px">' + html + '</div>' +
                    '<div class="sa-report-grid-column-text-last">' + subHtml + '</div>'
                );
            }
        }
        else {
            Ext.fly(el).removeCls(multiLineCls);
        }
    },

    autoSize(columns) {
        var tm = this.headerTextMetrics,
            htmlEncode = Ext.String.htmlEncode,
            doc = document,
            el, htmlContents, widths;

        if (!tm) {
            tm = SA.view.ReportGrid.prototype.headerTextMetrics = new SA.TextMetrics();

            el = doc.createElement('div');

            el.className = 'sa-grid x-border-box';
            el.setAttribute('style', 'position: absolute; visibility: hidden');
            el.innerHTML = '<div class="sa-grid-inner"><div class="sa-grid-header"><div class="sa-grid-header-normal"><div class="sa-grid-column"></div></div></div></div>';

            doc.body.appendChild(el);

            tm.bind(el.firstChild.firstChild.firstChild.firstChild);

            doc.body.removeChild(el);
        }

        tm.setStyle('line-height', '15px');

        htmlContents = columns.map(column => {
            var text = column.text;

            if (column.encodeText) {
                text = htmlEncode(text);
            }

            return text;
        });

        widths = tm.getWidths(htmlContents);

        columns.forEach((column, index) => {
            var autoWidth = column.autoWidth,
                frameWidth = 29,
                minColumnWidth = column.minAutoWidth || 90,
                maxColumnWidth = typeof autoWidth === 'number' ? autoWidth : 300,
                maxTextWidth = maxColumnWidth - frameWidth,
                width = column.textAutoWidth = widths[index],
                htmlContent, potentialWidths, heights;

            if (width > maxTextWidth && width < 2 * maxTextWidth) {
                htmlContent = column.text;

                if (column.encodeText) {
                    htmlContent = htmlEncode(htmlContent);
                }

                potentialWidths = [];

                for (let potentialWidth = maxTextWidth - 8 ; potentialWidth > width / 2 - 16 ; potentialWidth -= 8) {
                    potentialWidths.push(potentialWidth);
                }

                heights = tm.getHeights(htmlContent, potentialWidths);

                for (let wrapIndex = heights.length - 1 ; wrapIndex >= 0 ; --wrapIndex) {
                    if (heights[wrapIndex] < 40) {
                        width = potentialWidths[wrapIndex];
                        break;
                    }
                }
            }

            column.width = Ext.Number.constrain(width + frameWidth, minColumnWidth, maxColumnWidth);
        });
    },

    contentSize(columns) {
        var tm = this.contentTextMetrics,
            htmlEncode = Ext.String.htmlEncode,
            doc = document,
            frameWidth = 21,
            el, htmlContents, widths, measuredColumns;

        if (!tm) {
            tm = SA.view.ReportGrid.prototype.contentTextMetrics = new SA.TextMetrics();

            el = doc.createElement('div');

            el.className = 'sa-grid x-border-box';
            el.setAttribute('style', 'position: absolute; visibility: hidden');
            el.innerHTML = '<table class="sa-grid-table"><tbody class="sa-grid-header"><tr class="sa-grid-row"><td class="sa-grid-cell sa-grid-cell-normal"></td></tr></tbody></table>';

            doc.body.appendChild(el);

            tm.bind(el.firstChild.firstChild.firstChild.firstChild);

            doc.body.removeChild(el);
        }

        measuredColumns = [];
        htmlContents = [];

        columns.forEach(column => {
            if (typeof column.contentWidth !== 'number') {
                column.contentWidth = 300;
            }

            if (column.width >= column.contentWidth) {
                return;
            }

            var field = column.dataIndex,
                minLength = (column.width - frameWidth) / 10, 
                values = [];

            this.data.forEach(row => {
                var value = row[field];

                if (value && value.length > minLength) {
                    values.push(row[field]);
                }
            });

            if (!values.length) {
                return;
            }

            if (values.length > 100) {
                values.sort((a, b) => b.length - a.length);

                values.length = 100;
            }

            if (column.encodeCells) {
                values = values.map(htmlEncode);
            }

            measuredColumns.push(column);
            htmlContents.push(values.join('<br>'));
        });

        if (!htmlContents.length) {
            return;
        }

        widths = tm.getWidths(htmlContents);

        widths.forEach((width, index) => {
            var column = measuredColumns[index];

            width += frameWidth;

            width = Math.min(width, column.contentWidth);

            if (width > column.width) {
                column.width = width;
            }
        });
    },

    createScrollListenerForMenuDisposal(cellEl, menu) {
        var getCellXY = () => Ext.fly(cellEl).getXY(),
            initialCellXY = getCellXY(),
            cellMoved = () => !Ext.Array.equals(initialCellXY, getCellXY());

        this.normalWrap.on('scroll', onGridScroll);

        return () => this.normalWrap.un('scroll', onGridScroll);

        function onGridScroll() {
            if (cellMoved()) {
                menu.destroy();
            }
        }
    },

    getHeaderHtmlForAttribute(attribute) {
        return SA.BadgedAttributeLabel.getHtml({attribute});
    },

    setColumns(columns) {
        var autoSizeColumns, contentSizeColumns;

        this.needsAutoSizeColumns = false;

        autoSizeColumns = columns.filter(column => column.autoWidth);

        if (autoSizeColumns.length) {
            this.autoSize(autoSizeColumns);
        }

        contentSizeColumns = columns.filter(column => column.contentWidth);

        if (contentSizeColumns.length) {
            this.contentSize(contentSizeColumns);
        }

        this.callParent([columns]);
    },

    setData() {
        this.callParent(arguments);

        this.setColumns(this.columns);
    },

    showMenu(cfg) {
        var {el, items, defaults, includeHeader = true} = (Ext.isObject(cfg) ? cfg : {}),
            el = el || cfg,
            items = items || arguments[1],
            defaults = defaults || arguments[2],
            menu = this.lastMenu,
            removeScrollListener;

        if (menu && this.lastMenuEl === el && menu.wasRecentlyVisible()) {
            return;
        }

        this.lastMenuEl = el;

        Ext.fly(el).addCls('sa-grid-cell-selected');

        if (includeHeader) {
            items = [{
                xtype: 'simple-container',
                cls: 'sa-report-grid-menu-header',

                items: [{
                    xtype: 'close-button'
                }]
            }].concat(items);
        }

        defaults = Object.assign({
            view: this.projectView,

            deferHideParentMenus() {
                Ext.destroy(this.up('arrow-menu'));
            }
        }, defaults);

        menu = this.lastMenu = Ext.widget({
            alignment: 'right',
            cls: getCls(),
            positionEl: el,
            target: this,
            track: true,
            width: 270,
            xtype: 'arrow-menu',

            defaults,
            items,

            listeners: {
                beforedestroy() {
                    removeScrollListener();

                    Ext.fly(el).removeCls('sa-grid-cell-selected');
                },

                beforerender(menu) {
                    menu.items.each(item => {
                        if (item.beforeMenuShow) {
                            item.beforeMenuShow();
                        }
                    });
                }
            }
        });

        removeScrollListener = this.createScrollListenerForMenuDisposal(el, menu);

        function getCls() {
            if (includeHeader) {
                return 'sa-report-grid-menu sa-report-grid-menu-has-header';
            }

            return 'sa-report-grid-menu';
        }
    },

    updateColumns() {
        if (!this.rendered) {
            return;
        }

        this.callParent();

        this.columns.forEach(column => {
            if (column.autoWidth) {
                this.applyHeaderWrapping(column);
            }
        });
    }
});